import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[appOnlyUppercase]'
})
export class OnlyUppercaseDirective {

  @HostListener('input', ['$event'])
  onInput(event: any) {
    const input = event.target as HTMLInputElement;
    const upper = input.value.toUpperCase();

    // Already uppercase: nothing to do. This also terminates the re-dispatch below.
    if (input.value === upper) return;

    const start = input.selectionStart;
    const end = input.selectionEnd;

    input.value = upper;
    input.setSelectionRange(start, end);

    // Setting .value programmatically doesn't emit an input event, so Angular's
    // form binding would keep the pre-uppercase value without this.
    input.dispatchEvent(new Event('input', { bubbles: true }));
  }
}
